import React from 'react';
export function Footer() {
  return <>
      {/* Final CTA Section */}
      <section className="w-full bg-primary py-20 px-4 text-center" data-id="element-93">
        <div className="max-w-3xl mx-auto" data-id="element-94">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-white mb-4" data-id="element-95">
            Hol dir deine Zeit zurück
          </h2>
          <p className="text-white/90 text-base sm:text-lg font-medium max-w-2xl mx-auto mb-8" data-id="element-96">
            12 Bände. Über 480 Stunden. 5 Bonus-PDFs. Sofort verfügbar — heute
            nur 19€.
          </p>
          <a href="https://sportunterricht-fertig.example/checkout" className="inline-flex items-center justify-center gap-2 bg-white text-primary font-bold text-lg sm:text-xl px-10 py-4 rounded-2xl hover:bg-bg-main transition-colors shadow-lg" data-id="element-97">
            <span aria-hidden="true" data-id="element-98">🚀</span>
            ICH WILL SPORTUNTERRICHT FERTIG JETZT
          </a>
          <p className="text-white/80 text-xs sm:text-sm font-medium flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-6" data-id="element-99">
            <span className="flex items-center gap-1" data-id="element-100">
              <span aria-hidden="true" data-id="element-101">🔒</span> Sicherer Kauf
            </span>
            <span className="flex items-center gap-1" data-id="element-102">
              <span aria-hidden="true" data-id="element-103">⚡</span> Sofortiger Zugang
            </span>
            <span className="flex items-center gap-1" data-id="element-104">
              <span aria-hidden="true" data-id="element-105">🛡️</span> 7 Tage Geld-zurück-Garantie
            </span>
            <span className="flex items-center gap-1" data-id="element-106">
              <span aria-hidden="true" data-id="element-107">📘</span> 100% PDF
            </span>
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full bg-[#1A1A1A] py-12 px-4" data-id="element-108">
        <div className="max-w-4xl mx-auto text-center" data-id="element-109">
          <div className="text-white text-2xl font-serif font-black tracking-widest mb-2 flex items-center justify-center gap-2" data-id="element-110">
            <span data-id="element-111">⚽</span> SPORTUNTERRICHT FERTIG
          </div>
          <p className="text-white/60 text-sm mb-6" data-id="element-112">
            Das komplette Paket für Sportlehrer
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 text-sm text-white/70 mb-8" data-id="element-113">
            <a href="#" className="hover:text-white transition-colors" data-id="element-114">
              AGB
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-115">
              Datenschutz
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-116">
              Impressum
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-117">
              Kontakt
            </a>
          </div>

          <p className="text-white/40 text-xs" data-id="element-118">
            © {new Date().getFullYear()} SPORTUNTERRICHT FERTIG. Digitale
            PDF-Materialien für den Sportunterricht. Alle Rechte vorbehalten.
          </p>
        </div>
      </footer>
    </>;
}